module.exports = __webpack_public_path__ + "media/dorobek/assets/images/i-black-f7e4cf79d0840b796f7c4f498180bb1c.svg";